"use client"

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import he from "date-fns/locale/he"
import * as React from "react"

import { GlobalContextProvider } from "./GlobalContext"

export const ContextProviders = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <GlobalContextProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={he}>
        {children}
      </LocalizationProvider>
    </GlobalContextProvider>
  )
}
